import React, { useState, useEffect } from 'react';
import { useApi } from '../context/ApiProvider';
import PageHeader from '../components/PageHeader';
import LoadMoreBtn from '../components/LoadMoreBtn';
import LoadingScreen from '../components/LoadingScreen';
import defaultArt from '../assets/images/dj_kip_art.png';
import { Typography, Box } from '@mui/material';
import ListFilter from '../components/ListFilter';
import FollowedFilter from '../components/FollowedFilter';
import ArtistsTable from '../components/ArtistsTable';

const Artists = () => {
  const [artists, setArtists] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [paginationConfig, setPaginationConfig] = useState({
    order_by: 'artist_meta.set_count',
    order_direction: 'desc',
    search: '',
    followed_filter: '',
  });
  const [followedFilter, setFollowedFilter] = useState(false);
  const api = useApi();

  useEffect(() => {
    loadArtists();
  }, [paginationConfig]);

  const loadArtists = async () => {
    setLoading(true);
    const response = await api.get('/artists', paginationConfig);
    if (response.ok) {
      setArtists(response.body.data);
      setPagination(response.body.pagination);
      setPage(1);
    } else {
      console.log(response);
    }
    setLoading(false);
  };

  const loadMore = async () => {
    setLoadingMore(true);
    const response = await api.get('/artists', {
      ...paginationConfig,
      offset: 20 * page,
    });
    if (response.ok) {
      setArtists([...artists, ...response.body.data]);
      setPagination(response.body.pagination);
      setPage(page + 1);
    } else {
      console.log(response);
    }
    setLoadingMore(false);
  };

  function onFilter(genre, sortBy, sortDirection) {
    setPaginationConfig({
      ...paginationConfig,
      genre: genre,
      order_direction: sortDirection,
      order_by: `artist_meta.${sortBy}`,
    });
  }

  const handleFollowedFilterChange = (event) => {
    const newFollowedFilter = event.target.checked;
    setFollowedFilter(newFollowedFilter);
    setPaginationConfig({
      ...paginationConfig,
      followed_filter: newFollowedFilter ? 'true' : '',
    });
  };

  return (
    <>
      {loading && <LoadingScreen />}
      <PageHeader backgroundArt={defaultArt} minHeight={350}>
        <Typography variant="h3" fontWeight="bold" mt={4}>
          Discover{' '}
          <Typography
            variant="h3"
            component="span"
            color="primary"
            fontWeight="bold"
          >
            Artists
          </Typography>
        </Typography>
        <Typography mt={2}>Musical talent from around the world</Typography>
      </PageHeader>
      <Box sx={{ padding: { xs: '20px', lg: '30px 0' }, textAlign: 'center' }}>
        <Box my={2}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <FollowedFilter
              checked={followedFilter}
              onChange={handleFollowedFilterChange}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
              <ListFilter onFilter={onFilter} listType="artists" />
            </Box>
          </Box>
          <ArtistsTable
            items={artists}
            onTableInteraction={setPaginationConfig}
            tableInteractionConfig={paginationConfig}
          />
        </Box>
        <LoadMoreBtn
          pagination={pagination}
          onLoadMoreClick={loadMore}
          loading={loadingMore}
        />
      </Box>
    </>
  );
};

export default Artists;
